<page name="dashboard.pstxAccount" productBadge="pstx" headerType="h2">
  <ng-container *ngIf="isWalletFound">
    <agmo-loading *ngIf="isLoading && isWalletLoading"></agmo-loading>

    <div class="row">
      <ng-container *ngIf="!isWalletLoading && wallet">
        <div class="col-md-6 tw-pb-5">
          <div class="panel-container">
            <div class="tw-pb-2 tw-text-2xl tw-font-medium tw-capitalize tw-text-[#7F7F7F]">
              {{ 'Account balance' | translate }}
            </div>
            <div class="tw-flex">
              <div class="tw-text-5xl tw-text-black">
                {{ wallet.balance | numberSuffix: { numberFormat: '1.2-2' } }}
              </div>
            </div>
            <div *ngIf="isMaster" class="tw-flex tw-flex-wrap tw-pt-5">
              <div
                class="btn tw-flex tw-cursor-pointer tw-items-center tw-rounded-lg tw-bg-[#4EAC5F] tw-text-white max-[364px]:tw-mb-3"
                (click)="deposit()"
              >
                <mat-icon svgIcon="icon-credit" class="tw-mr-2 tw-text-white"></mat-icon>
                <div>{{ 'mysec.TopUp' | translate }}</div>
              </div>
              <div
                class="btn tw-flex tw-cursor-pointer tw-items-center tw-rounded-lg tw-border-[#D0D5DD] tw-text-[#344054]"
                (click)="withdrawValidation()"
              >
                <mat-icon svgIcon="icon-debit" class="tw-mr-2 tw-text-[#323232]"></mat-icon>
                <div>{{ 'mysec.Withdraw' | translate }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 tw-pb-5">
          <div class="panel-container">
            <div class="tw-flex tw-items-center tw-pb-3">
              <div class="tw-text-2xl tw-font-medium tw-text-[#7F7F7F]">
                {{ 'Balance on Hold' | translate }}
              </div>
              <button
                type="button"
                class="pitchin-icon-info-circle tw-ml-2 tw-h-4 tw-w-4 tw-cursor-pointer tw-border-0 tw-bg-transparent tw-p-0"
                placement="top"
                [attr.aria-label]="'mysec.balanceOnHoldTooltip' | translate"
                [ngbTooltip]="'mysec.balanceOnHoldTooltip' | translate"
              ></button>
            </div>
            <div
              class="tw-text-5xl tw-text-black"
              [class.tw-text-[#DADADA]]="wallet.pendingAmount == 0"
            >
              {{ wallet.pendingAmount | numberSuffix: { numberFormat: '1.2-2' } }}
            </div>

            <!-- #123: Balance on Hold breakdown — two inline bucket rows whose
                 subtotals reconcile to the headline pendingAmount above.
                 #124: rows are now drillable when non-zero — desktop opens an
                 anchored popover, mobile a bottom sheet (opener picks by viewport).
                 A zero bucket stays inert (no chevron, no popover, no cursor). -->
            <hr class="tw-w-full" />
            <div class="balance-hold-breakdown tw-flex tw-flex-col">
              <button
                type="button"
                class="balance-hold-row"
                data-bucket="open-orders"
                [class.balance-hold-row--drillable]="isBucketDrillable('open-orders')"
                [disabled]="!isBucketDrillable('open-orders')"
                [ngbPopover]="breakdownPopover"
                triggers="manual"
                [autoClose]="'outside'"
                placement="bottom-start"
                container="body"
                popoverClass="hold-breakdown-popover"
                #ooPopover="ngbPopover"
                (click)="openOpenOrdersBreakdown(ooPopover)"
              >
                <span class="balance-hold-row__label">
                  <span
                    *ngIf="isBucketDrillable('open-orders')"
                    class="balance-hold-row__chevron"
                    [class.balance-hold-row__chevron--open]="ooPopover.isOpen()"
                  ></span>
                  <span>{{ 'mysec.pstxOpenOrders' | translate }}</span>
                </span>
                <span class="balance-hold-row__amount">
                  {{ wallet.openOrdersHoldAmount | numberSuffix: { numberFormat: '1.2-2' } }}
                </span>
              </button>

              <button
                type="button"
                class="balance-hold-row"
                data-bucket="withdrawal-requests"
                [class.balance-hold-row--drillable]="isBucketDrillable('withdrawal-requests')"
                [disabled]="!isBucketDrillable('withdrawal-requests')"
                [ngbPopover]="breakdownPopover"
                triggers="manual"
                [autoClose]="'outside'"
                placement="bottom-start"
                container="body"
                popoverClass="hold-breakdown-popover"
                #wrPopover="ngbPopover"
                (click)="openWithdrawalsBreakdown(wrPopover)"
              >
                <span class="balance-hold-row__label">
                  <span
                    *ngIf="isBucketDrillable('withdrawal-requests')"
                    class="balance-hold-row__chevron"
                    [class.balance-hold-row__chevron--open]="wrPopover.isOpen()"
                  ></span>
                  <span>{{ 'mysec.withdrawalRequests' | translate }}</span>
                </span>
                <span class="balance-hold-row__amount">
                  {{
                    wallet.withdrawalRequestsHoldAmount | numberSuffix: { numberFormat: '1.2-2' }
                  }}
                </span>
              </button>

              <button
                type="button"
                class="balance-hold-row"
                data-bucket="ecf-investment"
                [class.balance-hold-row--drillable]="isBucketDrillable('ecf-investment')"
                [disabled]="!isBucketDrillable('ecf-investment')"
                [ngbPopover]="breakdownPopover"
                triggers="manual"
                [autoClose]="'outside'"
                placement="bottom-start"
                container="body"
                popoverClass="hold-breakdown-popover"
                #ecfPopover="ngbPopover"
                (click)="openEcfInvestmentsBreakdown(ecfPopover)"
              >
                <span class="balance-hold-row__label">
                  <span
                    *ngIf="isBucketDrillable('ecf-investment')"
                    class="balance-hold-row__chevron"
                    [class.balance-hold-row__chevron--open]="ecfPopover.isOpen()"
                  ></span>
                  <span>{{ 'mysec.ecfInvestment' | translate }}</span>
                </span>
                <span class="balance-hold-row__amount">
                  {{ wallet.ecfInvestmentHoldAmount | numberSuffix: { numberFormat: '1.2-2' } }}
                </span>
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <agmo-loading *ngIf="!isLoading && isWalletLoading"></agmo-loading>

    <div class="tw-scroll-mt-24" #transactionTable>
      <ng-container *ngIf="isMaster && !isLoading">
        <div class="row tw-mb-5 tw-mt-4">
          <div class="col-12 tw-flex tw-justify-between max-[1100px]:tw-flex-wrap">
            <div
              class="tw-flex tw-w-4/5 tw-items-center max-[1100px]:tw-w-full max-[1100px]:tw-pb-4"
            >
              <div class="p-text-h3 tw-pr-5 tw-text-black">
                {{ 'mysec.transactionHistory' | translate }}
              </div>
            </div>
            <div
              class="input-field input-md tw-flex tw-w-1/5 tw-justify-end max-[1100px]:tw-w-full max-[1100px]:tw-pb-4"
            >
              <!-- Mobile: "Event filters ▽" / "Status filters ▽" — two INDEPENDENT
                   dropdowns (own ngbDropdown each), so each anchors correctly to its
                   own trigger and only one can be open at a time (enforced below via
                   openChange, since opening one always closes the other). -->
              <div class="wallet-filter-menu__mobile-triggers tw-hidden max-[1100px]:tw-flex">
                <div
                  class="dropdown"
                  ngbDropdown
                  [autoClose]="'outside'"
                  #eventFilterDropdown="ngbDropdown"
                  (openChange)="onEventFilterDropdownOpenChange($event, statusFilterDropdown)"
                >
                  <div
                    class="wallet-filter-menu__mobile-trigger"
                    id="filterButtonEventMobile"
                    ngbDropdownToggle
                    [class.wallet-filter-menu__mobile-trigger--active]="isEventFilterApplied()"
                  >
                    {{ 'mysec.eventFilters' | translate }} ▽
                  </div>
                  <div
                    class="dropdown-menu wallet-filter-menu wallet-filter-menu--single"
                    ngbDropdownMenu
                    role="menu"
                    aria-labelledby="filterButtonEventMobile"
                  >
                    <ng-container
                      *ngTemplateOutlet="
                        eventFilterFields;
                        context: { dropdown: eventFilterDropdown, prefix: 'mobile-' }
                      "
                    ></ng-container>
                  </div>
                </div>

                <div
                  class="dropdown"
                  ngbDropdown
                  [autoClose]="'outside'"
                  #statusFilterDropdown="ngbDropdown"
                  (openChange)="onStatusFilterDropdownOpenChange($event, eventFilterDropdown)"
                >
                  <div
                    class="wallet-filter-menu__mobile-trigger"
                    id="filterButtonStatusMobile"
                    ngbDropdownToggle
                    [class.wallet-filter-menu__mobile-trigger--active]="isStatusFilterApplied()"
                  >
                    {{ 'mysec.statusFilters' | translate }} ▽
                  </div>
                  <div
                    class="dropdown-menu wallet-filter-menu wallet-filter-menu--single"
                    ngbDropdownMenu
                    role="menu"
                    aria-labelledby="filterButtonStatusMobile"
                  >
                    <ng-container
                      *ngTemplateOutlet="
                        statusFilterFields;
                        context: { dropdown: statusFilterDropdown, prefix: 'mobile-' }
                      "
                    ></ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ng-container *ngIf="isTransactionListLoading">
          <ng-container *ngTemplateOutlet="loading"></ng-container>
        </ng-container>

        <div class="row" *ngIf="!isTransactionListLoading">
          <div class="col-12">
            <div class="p-table__wrapper">
              <div class="p-table__body max-[1100px]:tw-hidden">
                <mat-table class="responsive-table p-table" [dataSource]="transactionList">
                  <ng-container matColumnDef="Event">
                    <mat-header-cell *matHeaderCellDef>
                      <!-- Desktop: filter trigger anchored directly on the column
                           header (Figma), replacing the old standalone "More Filters"
                           button. Mobile keeps its own triggers above the table. -->
                      <div
                        class="wallet-column-filter"
                        ngbDropdown
                        [autoClose]="'outside'"
                        container="body"
                        placement="bottom-left bottom-right auto"
                        #eventHeaderFilterDropdown="ngbDropdown"
                        (openChange)="onEventHeaderFilterDropdownOpenChange($event)"
                      >
                        <div
                          class="wallet-column-filter__trigger"
                          id="filterButtonEventDesktop"
                          ngbDropdownToggle
                          [class.wallet-column-filter__trigger--active]="isEventFilterApplied()"
                        >
                          <span>{{ 'common.event' | translate }}</span>
                          <span class="wallet-column-filter__icon">▽</span>
                        </div>
                        <div
                          class="dropdown-menu wallet-filter-menu wallet-filter-menu--single"
                          ngbDropdownMenu
                          role="menu"
                          aria-labelledby="filterButtonEventDesktop"
                        >
                          <ng-container
                            *ngTemplateOutlet="
                              eventFilterFields;
                              context: { dropdown: eventHeaderFilterDropdown, prefix: 'desktop-' }
                            "
                          ></ng-container>
                        </div>
                      </div>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let item">
                      <div class="tw-flex tw-flex-col">
                        <div class="text-black" *ngIf="item.walletTransactionHistory?.event">
                          {{
                            eventDisplayLabelKey(item.walletTransactionHistory.event) | translate
                          }}
                        </div>
                        <div class="text-black tw-italic">
                          {{
                            item.walletTransactionHistory.paymentType
                              ? ('paymentType.' +
                                  PaymentType[item.walletTransactionHistory.paymentType]
                                | translate)
                              : ''
                          }}
                        </div>
                      </div>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="Amount">
                    <mat-header-cell *matHeaderCellDef>
                      {{ 'mysec.amount' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let item" [ngClass]="'font-weight-bold tw-text-xs'">
                      <!-- #: Amount cell is plain text, not a link — completed Buy/Sell
                           rows open Order Summary only via the "View" action button. -->
                      <div
                        *ngIf="item.walletTransactionHistory?.amount > 0"
                        [ngClass]="CreditFlow[item.walletTransactionHistory?.creditFlow]"
                      >
                        {{
                          item.walletTransactionHistory?.creditFlow == CreditFlow.Debit ||
                          item.walletTransactionHistory?.creditFlow == CreditFlow.Withdraw
                            ? '-'
                            : '+'
                        }}
                        {{
                          item.walletTransactionHistory?.amount
                            | numberSuffix: { numberFormat: '1.2-2' }
                        }}
                      </div>
                      <div *ngIf="item.walletTransactionHistory?.amount < 0" class="Debit">
                        -
                        {{
                          item.walletTransactionHistory?.amount * -1
                            | numberSuffix: { numberFormat: '1.2-2' }
                        }}
                      </div>
                      <div
                        *ngIf="item.walletTransactionHistory?.amount === 0"
                        class="font-weight-bold !tw-text-body"
                      >
                        {{
                          item.walletTransactionHistory?.amount * -1
                            | numberSuffix: { numberFormat: '1.2-2' }
                        }}
                      </div>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="TickerCode">
                    <mat-header-cell *matHeaderCellDef
                      > {{ 'Counter/Campaign' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let item" [ngClass]="'tw-text-xs tw-uppercase'">
                      <ng-container *ngIf="isCounterLinkable(item); else counterCol">
                        <a
                          class="p-link-primary p-link-underline tw-uppercase"
                          [routerLink]="counterLink(item)"
                          (click)="handleTickerCodeClick()"
                        >
                          {{ displayCounter(item) }}
                        </a>
                      </ng-container>
                      <ng-template #counterCol>
                        <ng-container *ngIf="!displayCounter(item); else counterWithoutLink">
                          {{ '-' }}
                        </ng-container>
                        <ng-template #counterWithoutLink>
                          {{ displayCounter(item) }}
                        </ng-template>
                      </ng-template>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="CreatedDate">
                    <mat-header-cell *matHeaderCellDef
                      >{{ 'common.date' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let item" [ngClass]="'tw-text-xs'">
                      <div class="tw-flex tw-flex-col">
                        <div>
                          {{ item.walletTransactionHistory?.createdAt | amDateFormat: dateFormat }}
                        </div>
                        <div>
                          {{ item.walletTransactionHistory?.createdAt | amDateFormat: timeFormat }}
                        </div>
                      </div>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="Status">
                    <mat-header-cell *matHeaderCellDef>
                      <div class="tw-flex tw-items-center">
                        <!-- Desktop: filter trigger anchored directly on the column
                             header (Figma) — see the Event header above for why
                             this uses ViewChild instead of a shared template ref. -->
                        <div
                          class="wallet-column-filter"
                          ngbDropdown
                          [autoClose]="'outside'"
                          container="body"
                          placement="bottom-left bottom-right auto"
                          #statusHeaderFilterDropdown="ngbDropdown"
                          (openChange)="onStatusHeaderFilterDropdownOpenChange($event)"
                        >
                          <div
                            class="wallet-column-filter__trigger"
                            id="filterButtonStatusDesktop"
                            ngbDropdownToggle
                            [class.wallet-column-filter__trigger--active]="isStatusFilterApplied()"
                          >
                            <span>{{ 'common.status' | translate }}</span>
                            <span class="wallet-column-filter__icon">▽</span>
                          </div>
                          <div
                            class="dropdown-menu wallet-filter-menu wallet-filter-menu--single"
                            ngbDropdownMenu
                            role="menu"
                            aria-labelledby="filterButtonStatusDesktop"
                          >
                            <ng-container
                              *ngTemplateOutlet="
                                statusFilterFields;
                                context: {
                                  dropdown: statusHeaderFilterDropdown,
                                  prefix: 'desktop-',
                                }
                              "
                            ></ng-container>
                          </div>
                        </div>
                      </div>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let item">
                      <div
                        class="d-flex p-badge flex-row align-items-center hover:tw-cursor-help"
                        [matTooltip]="
                          getTransactionStatusTooltip(item.walletTransactionHistory?.status)
                            | translate
                        "
                        [class.completed]="isCompletedTradeRow(item)"
                        [class.approved]="
                          !isCompletedTradeRow(item) &&
                          [
                            WalletTransactionStatus.Approved,
                            WalletTransactionStatus.FPXSuccessful,
                          ].includes(item.walletTransactionHistory?.status)
                        "
                        [class.pending]="
                          [
                            WalletTransactionStatus.PendingApproval,
                            WalletTransactionStatus.PendingFPXServerResponse,
                          ].includes(item.walletTransactionHistory?.status)
                        "
                        [class.rejected]="
                          item.walletTransactionHistory?.status === WalletTransactionStatus.Declined
                        "
                        [class.failed]="
                          item.walletTransactionHistory?.status === WalletTransactionStatus.Failed
                        "
                        [class.cancelled]="
                          item.walletTransactionHistory?.status ===
                          WalletTransactionStatus.Cancelled
                        "
                      >
                        <span class="status-badge__icon"></span>
                        <div>
                          <!-- Trade rows (Buy/Sell PSTX, Approved/FPXSuccessful) show "Completed";
                               Top up / Withdraw keep Approved / Pending. -->
                          {{
                            (isCompletedTradeRow(item)
                              ? 'mysec.Completed'
                              : 'mysec.' +
                                WalletTransactionStatus[item.walletTransactionHistory?.status]
                            ) | translate
                          }}
                        </div>
                      </div>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="Action">
                    <mat-header-cell *matHeaderCellDef>{{
                      'common.actions' | translate
                    }}</mat-header-cell>
                    <mat-cell *matCellDef="let item">
                      <div class="action-cell tw-flex tw-items-center tw-gap-2">
                        <!-- Completed trade rows -> open the existing Order Summary popup -->
                        <button
                          *ngIf="isCompletedTradeRow(item)"
                          type="button"
                          class="action-btn"
                          (click)="showOrderSummary(item)"
                        >
                          <svg
                            class="action-btn__icon"
                            width="14"
                            height="14"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1.03 6.17a.5.5 0 0 1 0-.35A5.5 5.5 0 0 1 6 2.5a5.5 5.5 0 0 1 4.96 3.32.5.5 0 0 1 0 .35A5.5 5.5 0 0 1 6 9.49a5.5 5.5 0 0 1-4.97-3.32Z"
                              stroke="currentColor"
                              stroke-width="1.1"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M6 7.5A1.5 1.5 0 1 0 6 4.5a1.5 1.5 0 0 0 0 3Z"
                              stroke="currentColor"
                              stroke-width="1.1"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          {{ 'common.view' | translate }}
                        </button>

                        <!-- Pending rows -> existing cancel flow -->
                        <button
                          *ngIf="isPendingRow(item)"
                          type="button"
                          class="action-btn action-btn--danger"
                          (click)="cancelTransaction(item.walletTransactionHistory.id)"
                        >
                          {{ 'common.cancel' | translate }}
                        </button>

                        <!-- Everything else (incl. pending non-trade rows) -> copy reference number -->
                        <button
                          *ngIf="!isCompletedTradeRow(item)"
                          type="button"
                          class="action-btn"
                          (click)="copyTransactionId(item)"
                        >
                          <img
                            class="action-btn__icon"
                            src="assets/img/icons/common/clipboard_icon_grey@2x.png"
                            alt=""
                          />
                          {{ 'mysec.transactionId' | translate }}
                        </button>
                      </div>
                    </mat-cell>
                  </ng-container>

                  <mat-header-row *matHeaderRowDef="displayColumns"> </mat-header-row>
                  <mat-row *matRowDef="let item; columns: displayColumns"> </mat-row>
                </mat-table>
              </div>

              <!-- Mobile: card list replaces the table below ~1100px. Collapsed by
                   default; click anywhere on a card to expand. Completed Buy/Sell
                   trades expand into the full order breakdown (previously only
                   available via the "View" popup); everything else expands into
                   its action buttons (Cancel/Transaction ID). -->
              <div class="tw-hidden max-[1100px]:tw-block">
                <!-- The hide/show utility is on this WRAPPER, not .wallet-tx-cards
                     itself — that class sets its own `display`, which ties with
                     (and can lose to) `tw-hidden` on the same element. -->
                <div class="wallet-tx-cards">
                  <div
                    class="wallet-tx-card"
                    *ngFor="let item of transactionList"
                    [class.wallet-tx-card--expanded]="
                      isRowExpanded(item) && isCompletedTradeRow(item)
                    "
                    [class.wallet-tx-card--static]="!isCompletedTradeRow(item)"
                    (click)="isCompletedTradeRow(item) && toggleRowExpanded(item)"
                  >
                    <div class="wallet-tx-card__summary">
                      <div class="wallet-tx-card__main">
                        <div class="wallet-tx-card__title-row">
                          <ng-container *ngIf="displayCounter(item); else eventTitle">
                            <span class="wallet-tx-card__ticker">{{
                              displayCounter(item) | uppercase
                            }}</span>
                            <span
                              *ngIf="isBuyRow(item) !== null"
                              class="order-type-badge"
                              [ngClass]="
                                isBuyRow(item) ? 'order-type-badge--buy' : 'order-type-badge--sell'
                              "
                            >
                              PSTX
                              {{
                                (isBuyRow(item) ? 'mysec.buy' : 'mysec.sell')
                                  | translate
                                  | uppercase
                              }}
                            </span>
                            <!-- Non-trade rows with a counter (ECF investment) show the
                                 event name next to the ticker instead of a PSTX badge. -->
                            <ng-container *ngIf="isBuyRow(item) === null">
                              <ng-container *ngTemplateOutlet="nonTradeTickerTitle"></ng-container>
                            </ng-container>
                          </ng-container>
                          <!-- Plain event name (Withdrawal/Top up) — its own class, NOT
                             __ticker, so it keeps natural case like the desktop Event
                             column instead of being force-uppercased like a ticker code. -->
                          <ng-template #eventTitle>
                            <span class="wallet-tx-card__event-title">
                              {{
                                eventDisplayLabelKey(item.walletTransactionHistory?.event)
                                  | translate
                              }}
                            </span>
                          </ng-template>
                          <ng-template #nonTradeTickerTitle>
                            <span class="wallet-tx-card__event-title">
                              {{
                                eventDisplayLabelKey(item.walletTransactionHistory?.event)
                                  | translate
                              }}
                            </span>
                          </ng-template>
                        </div>
                        <div class="wallet-tx-card__date">
                          {{ item.walletTransactionHistory?.createdAt | amDateFormat: dateFormat }}
                          ·
                          {{ item.walletTransactionHistory?.createdAt | amDateFormat: timeFormat }}
                        </div>
                        <div
                          class="d-flex p-badge flex-row align-items-center wallet-tx-card__status"
                          [class.completed]="isCompletedTradeRow(item)"
                          [class.approved]="
                            !isCompletedTradeRow(item) &&
                            [
                              WalletTransactionStatus.Approved,
                              WalletTransactionStatus.FPXSuccessful,
                            ].includes(item.walletTransactionHistory?.status)
                          "
                          [class.pending]="
                            [
                              WalletTransactionStatus.PendingApproval,
                              WalletTransactionStatus.PendingFPXServerResponse,
                            ].includes(item.walletTransactionHistory?.status)
                          "
                          [class.rejected]="
                            item.walletTransactionHistory?.status ===
                            WalletTransactionStatus.Declined
                          "
                          [class.failed]="
                            item.walletTransactionHistory?.status === WalletTransactionStatus.Failed
                          "
                          [class.cancelled]="
                            item.walletTransactionHistory?.status ===
                            WalletTransactionStatus.Cancelled
                          "
                        >
                          <span class="status-badge__icon"></span>
                          <div>
                            {{
                              (isCompletedTradeRow(item)
                                ? 'mysec.Completed'
                                : 'mysec.' +
                                  WalletTransactionStatus[item.walletTransactionHistory?.status]
                              ) | translate
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="wallet-tx-card__right">
                        <div
                          class="wallet-tx-card__amount"
                          [ngClass]="
                            item.walletTransactionHistory?.amount < 0
                              ? 'Debit'
                              : CreditFlow[item.walletTransactionHistory?.creditFlow]
                          "
                        >
                          {{
                            item.walletTransactionHistory?.amount < 0
                              ? '-'
                              : item.walletTransactionHistory?.creditFlow == CreditFlow.Debit ||
                                  item.walletTransactionHistory?.creditFlow == CreditFlow.Withdraw
                                ? '-'
                                : '+'
                          }}
                          {{
                            (item.walletTransactionHistory?.amount < 0
                              ? item.walletTransactionHistory?.amount * -1
                              : item.walletTransactionHistory?.amount
                            ) | numberSuffix: { numberFormat: '1.2-2' }
                          }}
                        </div>
                        <!-- Only completed Buy/Sell trades expand; Top Up / Withdrawal
                           have nothing to expand into, so they show no chevron. -->
                        <div
                          *ngIf="isCompletedTradeRow(item)"
                          class="wallet-tx-card__chevron"
                          [class.wallet-tx-card__chevron--up]="isRowExpanded(item)"
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4 6l4 4 4-4"
                              stroke="currentColor"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>

                    <!-- Collapsed default already shows the action buttons (no click
                       needed) — Top Up/Withdrawal never expand further; completed
                       Buy/Sell replace this row with the full breakdown on expand. -->
                    <div
                      class="wallet-tx-card__actions"
                      *ngIf="!isRowExpanded(item) || !isCompletedTradeRow(item)"
                    >
                      <div class="action-cell tw-flex tw-items-center tw-gap-2">
                        <!-- Mobile "View" = expand the card's inline breakdown (desktop
                           opens the popup instead). Explicit handler + stopPropagation
                           so it doesn't also double-fire via the card's own (click). -->
                        <button
                          *ngIf="isCompletedTradeRow(item)"
                          type="button"
                          class="action-btn"
                          (click)="$event.stopPropagation(); toggleRowExpanded(item)"
                        >
                          <svg
                            class="action-btn__icon"
                            width="14"
                            height="14"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1.03 6.17a.5.5 0 0 1 0-.35A5.5 5.5 0 0 1 6 2.5a5.5 5.5 0 0 1 4.96 3.32.5.5 0 0 1 0 .35A5.5 5.5 0 0 1 6 9.49a5.5 5.5 0 0 1-4.97-3.32Z"
                              stroke="currentColor"
                              stroke-width="1.1"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M6 7.5A1.5 1.5 0 1 0 6 4.5a1.5 1.5 0 0 0 0 3Z"
                              stroke="currentColor"
                              stroke-width="1.1"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          {{ 'common.view' | translate }}
                        </button>
                        <button
                          *ngIf="isPendingRow(item)"
                          type="button"
                          class="action-btn action-btn--danger"
                          (click)="
                            $event.stopPropagation();
                            cancelTransaction(item.walletTransactionHistory.id)
                          "
                        >
                          {{ 'common.cancel' | translate }}
                        </button>
                        <button
                          type="button"
                          class="action-btn"
                          (click)="$event.stopPropagation(); copyTransactionId(item)"
                        >
                          <img
                            class="action-btn__icon"
                            src="assets/img/icons/common/clipboard_icon_grey@2x.png"
                            alt=""
                          />
                          {{ 'mysec.transactionId' | translate }}
                        </button>
                      </div>
                    </div>

                    <div
                      class="wallet-tx-card__details"
                      *ngIf="isRowExpanded(item) && isCompletedTradeRow(item)"
                      (click)="$event.stopPropagation()"
                    >
                      <ng-container>
                        <ng-container *ngIf="item.orderSummary; else orderSummaryUnavailableMobile">
                          <div class="summary-card tw-mt-3">
                            <div class="table--row summary-card__head tw-grid tw-grid-cols-5">
                              <div>{{ 'mysec.shares' | translate }}</div>
                              <div class="tw-col-span-2 tw-text-right">
                                {{ 'mysec.pricePerShareShort' | translate }}
                              </div>
                              <div class="tw-col-span-2 tw-text-right">
                                {{ 'mysec.amount' | translate }}
                              </div>
                            </div>
                            <div
                              class="table--row summary-card__row tw-grid tw-grid-cols-5"
                              *ngFor="let detail of item.orderSummary?.orderDetail"
                            >
                              <div class="tw-tabular-nums">{{ detail.quantity }}</div>
                              <div
                                class="tw-col-span-2 tw-whitespace-nowrap tw-text-right tw-tabular-nums"
                              >
                                {{ detail.pricePerShare | numberSuffix: { numberFormat: '1.2-2' } }}
                              </div>
                              <div
                                class="tw-col-span-2 tw-whitespace-nowrap tw-text-right tw-font-semibold tw-tabular-nums"
                              >
                                {{ isBuyRow(item) ? '-' : '+' }}
                                {{
                                  (detail.amount < 0 ? -detail.amount : detail.amount)
                                    | numberSuffix: { numberFormat: '1.2-2' }
                                }}
                              </div>
                            </div>
                          </div>
                          <!-- Shares Value + Trading Fee grouped in one shaded box;
                             Total pulled out into a separate divided row (attachment 2). -->
                          <div class="summary-card summary-card--totals tw-mt-2">
                            <div class="table--row summary-card__row tw-grid tw-grid-cols-5">
                              <div class="summary-card__label tw-col-span-3 tw-font-medium">
                                {{ 'mysec.sharesValue' | translate }}
                              </div>
                              <div
                                class="tw-col-span-2 tw-whitespace-nowrap tw-text-right tw-font-semibold tw-tabular-nums"
                              >
                                {{ isBuyRow(item) ? '-' : '+' }}
                                {{
                                  (sharesValueFor(item) < 0
                                    ? -sharesValueFor(item)
                                    : sharesValueFor(item)
                                  ) | numberSuffix: { numberFormat: '1.2-2' }
                                }}
                              </div>
                            </div>
                            <div class="table--row summary-card__row tw-grid tw-grid-cols-5">
                              <div class="summary-card__label tw-col-span-3 tw-font-medium">
                                {{ 'mysec.tradingFee' | translate }}
                              </div>
                              <div
                                class="summary-card__label tw-col-span-2 tw-whitespace-nowrap tw-text-right tw-tabular-nums"
                              >
                                -
                                {{
                                  item.orderSummary?.tradingFee
                                    | numberSuffix: { numberFormat: '1.2-2' }
                                }}
                              </div>
                            </div>
                          </div>
                          <div
                            class="summary-total table--row tw-mt-2 tw-grid tw-grid-cols-5 tw-items-center"
                          >
                            <div class="tw-col-span-3 tw-font-bold">
                              {{ 'common.total' | translate }}
                            </div>
                            <div
                              class="tw-col-span-2 tw-whitespace-nowrap tw-text-right tw-font-bold tw-tabular-nums"
                              [ngClass]="
                                isBuyRow(item) ? 'tw-text-primary' : 'tw-text-secondary-light'
                              "
                            >
                              {{ isBuyRow(item) ? '-' : '+' }}
                              {{
                                (item.walletTransactionHistory?.amount < 0
                                  ? -item.walletTransactionHistory?.amount
                                  : item.walletTransactionHistory?.amount
                                ) | numberSuffix: { numberFormat: '1.2-2' }
                              }}
                            </div>
                          </div>
                        </ng-container>
                        <ng-template #orderSummaryUnavailableMobile>
                          <div class="tw-py-4 tw-text-center tw-text-body">
                            {{ 'mysec.orderSummaryUnavailable' | translate }}
                          </div>
                        </ng-template>
                        <div class="tw-mt-3 tw-text-center">
                          <a
                            [routerLink]="['/dashboard/orders']"
                            [queryParams]="{ tab: 'history', historyFilter: 'successful' }"
                            class="tw-font-semibold tw-text-secondary-light tw-underline"
                          >
                            {{ 'mysec.viewFullOrderInPstx' | translate }}
                          </a>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="tw-w-full tw-py-4 tw-text-center"
                *ngIf="!transactionList || transactionList.length == 0"
              >
                {{ 'common.noRecord' | translate }}
              </div>

              <div class="p-table__footer" *ngIf="total > params.take">
                <div class="p-table__pagination max-[990px]:!tw-hidden">
                  <ngb-pagination
                    [collectionSize]="total"
                    [(pageSize)]="params.take"
                    [(page)]="params.currentPage"
                    (pageChange)="getWalletTransaction(true)"
                    [maxSize]="5"
                    [rotate]="true"
                  >
                    <ng-template ngbPaginationPrevious>
                      <span class="p-table__pagination-icon">←</span>
                      <div class="p-table__pagination-label tw-pl-2">
                        {{ 'common.prev' | translate }}
                      </div>
                    </ng-template>
                    <ng-template class="page-no" ngbPaginationNumber let-page>
                      <div class="page-no">{{ page }}</div>
                    </ng-template>
                    <ng-template ngbPaginationNext>
                      <div class="p-table__pagination-label tw-pr-2">
                        {{ 'common.next' | translate }}
                      </div>
                      <span class="p-table__pagination-icon">→</span>
                    </ng-template>
                  </ngb-pagination>
                </div>
              </div>

              <div class="tw-hidden tw-w-full max-[990px]:tw-block" *ngIf="total > params.take">
                <ngb-pagination
                  class="mobile-pagination"
                  [collectionSize]="total"
                  [(pageSize)]="params.take"
                  [(page)]="params.currentPage"
                  (pageChange)="getWalletTransaction(true)"
                  [boundaryLinks]="false"
                >
                  <ng-template ngbPaginationPrevious>
                    <div class="pitchin-icon-arrow-left tw-h-5 tw-w-5"></div>
                  </ng-template>
                  <ng-template ngbPaginationPages let-page let-pages="pages">
                    <div class="ngb-custom-pages-item" *ngIf="pages.length > 0">
                      <div
                        class="col-form-label tw-flex tw-flex-nowrap tw-whitespace-nowrap tw-px-2"
                      >
                        <span
                          id="paginationInputLabel"
                          for="paginationInput"
                          class="tw-pr-2 tw-font-normal"
                          >Page</span
                        >
                        <span class="tw-pr-2">{{ page }}</span>
                        <span class="tw-font-normal">of</span>
                        <span id="paginationDescription" class="tw-pl-2">{{ pages.length }}</span>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ngbPaginationNext>
                    <div class="pitchin-icon-arrow-right tw-h-5 tw-w-5"></div>
                  </ng-template>
                </ngb-pagination>
              </div>
            </div>
          </div>
        </div>

        <div>
          <app-json-ld [itemLd]="walletFaqLd"></app-json-ld>
          <app-faq-accordion [accordionItems]="pageFaqs"></app-faq-accordion>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <div class="row my-5 tw-justify-center" *ngIf="!isWalletFound && !isWalletLoading">
    <div *ngIf="isMaster" class="col-12 text-center">
      <h6 class="font-weight-bold mb-0">{{ 'mysec.noTransactionActivity' | translate }}</h6>
      <h6 class="font-weight-bold mb-0">{{ 'mysec.activateWalletNowDesc' | translate }}</h6>
      <button class="btn btn-primary mt-3" type="button" (click)="activateWallet()">
        {{ 'mysec.activateNow' | translate }}
      </button>
    </div>

    <div *ngIf="!isMaster" class="col-lg-6 text-center">
      <h6 class="font-weight-bold mb-0">
        {{ 'mysec.subRepWalletActivationDescription' | translate }}
      </h6>
    </div>
  </div>
</page>

<!-- #124: desktop anchored-popover body. The opener feeds the row's NgbPopover
     with a HoldBreakdownData context; the shared content renders it identically
     to the mobile sheet. Navigate/dismiss are routed back through the host. -->
<ng-template #breakdownPopover let-data="data">
  <app-hold-breakdown-content
    [data]="data"
    (dismiss)="closeBreakdownPopovers()"
    (navigate)="onBreakdownNavigate($event)"
  ></app-hold-breakdown-content>
</ng-template>

<ng-template #dashed>-</ng-template>

<ng-template #loading>
  <agmo-loading></agmo-loading>
</ng-template>

<!-- Shared filter-field markup, reused via *ngTemplateOutlet by BOTH the desktop
     combined "More Filters" dropdown and the two independent mobile dropdowns —
     one source of truth for the checkboxes so the two layouts can't drift apart. -->
<!-- `prefix` namespaces the ids — this template renders twice at once
     (mobile trigger + desktop header trigger), and duplicate DOM ids break
     `label[for]` (it resolves to the FIRST matching id in the document,
     regardless of which instance the user actually clicked). -->
<ng-template #eventFilterFields let-dropdown="dropdown" let-prefix="prefix">
  <div class="wallet-filter-menu__title">{{ 'mysec.eventFilters' | translate }}</div>
  <div class="wallet-filter-menu__check">
    <input
      class="wallet-filter-menu__checkbox"
      type="checkbox"
      [id]="prefix + 'eventFilterAll'"
      [checked]="isAllEventFiltersSelected()"
      (change)="toggleEventFilter(WalletTransactionEvent.All)"
    />
    <label class="wallet-filter-menu__label" [for]="prefix + 'eventFilterAll'">
      {{ 'common.all' | translate }}
    </label>
  </div>
  <div *ngFor="let option of eventFilterOptions" class="wallet-filter-menu__check">
    <input
      class="wallet-filter-menu__checkbox"
      type="checkbox"
      [id]="prefix + 'eventFilter' + option.key"
      [checked]="isEventFilterSelected(option.key)"
      (change)="toggleEventFilter(option.key)"
    />
    <label class="wallet-filter-menu__label" [for]="prefix + 'eventFilter' + option.key">
      {{ option.labelKey | translate }}
    </label>
  </div>
  <div class="wallet-filter-menu__actions">
    <button type="button" class="wallet-filter-menu__clear" (click)="clearEventFilters()">
      {{ 'common.clear' | translate }}
    </button>
    <button
      type="button"
      class="wallet-filter-menu__apply"
      (click)="applyEventFilters(); dropdown?.close()"
    >
      {{ 'common.apply' | translate }}
    </button>
  </div>
</ng-template>

<!-- `prefix` namespaces the ids — see the comment on #eventFilterFields above. -->
<ng-template #statusFilterFields let-dropdown="dropdown" let-prefix="prefix">
  <div class="wallet-filter-menu__title">{{ 'mysec.statusFilters' | translate }}</div>
  <div class="wallet-filter-menu__check">
    <input
      class="wallet-filter-menu__checkbox"
      type="checkbox"
      [id]="prefix + 'statusFilterAll'"
      [checked]="isAllStatusFiltersSelected()"
      (change)="toggleStatusFilter(StatusFilterOption.All)"
    />
    <label class="wallet-filter-menu__label" [for]="prefix + 'statusFilterAll'">
      {{ 'common.all' | translate }}
    </label>
  </div>
  <div *ngFor="let option of statusFilterOptions" class="wallet-filter-menu__check">
    <input
      class="wallet-filter-menu__checkbox"
      type="checkbox"
      [id]="prefix + 'statusFilter' + option.key"
      [checked]="isStatusFilterSelected(option.key)"
      (change)="toggleStatusFilter(option.key)"
    />
    <label class="wallet-filter-menu__label" [for]="prefix + 'statusFilter' + option.key">
      {{ option.labelKey | translate }}
    </label>
  </div>
  <div class="wallet-filter-menu__actions">
    <button type="button" class="wallet-filter-menu__clear" (click)="clearStatusFilters()">
      {{ 'common.clear' | translate }}
    </button>
    <button
      type="button"
      class="wallet-filter-menu__apply"
      (click)="applyStatusFilters(); dropdown?.close()"
    >
      {{ 'common.apply' | translate }}
    </button>
  </div>
</ng-template>
